import { ReadonlyURLSearchParams } from 'next/navigation';

export const getQueryParam = (key: string) => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    return url.searchParams.get(key) ?? '';
  }
};

export const resetQueryParam = (key: string) => {
  if (typeof window !== 'undefined') {
    const url = new URL(location.origin + location.pathname);
    url.searchParams.delete(key);
    window.history.pushState({}, '', url);
  }
};

export const setQueryParam = (key: string, value = true) => {
  if (typeof window !== 'undefined') {
    const url = new URL(location.origin + location.pathname);
    url.searchParams.set(key, String(value));
    window.history.pushState({}, '', url);
  }
};

export const replaceQueryParam = (key: string, value = true) => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    url.searchParams.set(key, String(value));
    window.history.replaceState({}, '', url);
  }
};

export const hasQueryParam = (key: string) => {
  if (typeof window !== 'undefined') {
    const url = new URL(window?.location.href);
    return url.searchParams.has(key);
  }

  return false;
};

export const extractParam = (
  searchParams: ReadonlyURLSearchParams,
  key: string,
  defaultValue: unknown
) => {
  try {
    const param = searchParams.get(key);
    if (param) return JSON.parse(param);

    return defaultValue;
  } catch (error) {
    return defaultValue;
  }
};
